import { FETCH_ALL, CREATE, UPDATE, DELETE } from '../constants/actionTypes';

const initialState = []

// postsReducer:
const posts = (state = initialState, action) => {   // state is all posts which is initially empty array, state ~ posts
    switch (action.type) {
        // case 'LIKE':
        //     return state.map((post) => (post._id === action.payload._id ? action.payload : post));
        case DELETE:
            return state.filter((post) => post._id !== action.payload)
        case FETCH_ALL:
            return action.payload
        case CREATE:
            return [...state, action.payload];
        case UPDATE:
            return state.map((post) => (post._id === action.payload._id ? action.payload : post));
        default:
            return state;
    }
}

export default posts;

